import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { BankData, BankService } from '../../services/bank.service';

@Component({
  selector: 'app-create-bank',
  templateUrl: './create-bank.component.html',
  styleUrls: ['./create-bank.component.css']
})
export class CreateBankComponent implements OnInit {

  clabeError: boolean;

  bankForm: FormGroup;

  bankSelect: any[];
  utilitySelect: any[];
  currencySelect: any[];

  clabeCharsCurrent: number = 0;
  clabeCharsDesired: number = 18;

  constructor(
    private bankService: BankService,
    private bankData: BankData,
    private fb: FormBuilder,
  ) {
    this.bankSelect = bankData.bankSelect;
    this.utilitySelect = bankData.utilitySelect;
    this.currencySelect = Object.keys(bankData.currencies).map(value => ({
        value: value,
        ...bankData.currencies[value]
    }) );
  }

  ngOnInit() {
    this.createForm();
    console.log(this.currencySelect)

  }

  createForm() {
    this.bankForm = this.fb.group({
      bankName: ['', Validators.required],
      accountNumber: ['', Validators.required],
      CLABE: ['', [Validators.maxLength(18), Validators.minLength(18)]],
      utility: ['', Validators.required],
      currency: [this.currencySelect[0].value, Validators.required]
    });
  }

  onInputClabe(CLABE: string){
    this.clabeCharsCurrent = CLABE.length;
    this.clabeError = !(CLABE.length == 18);
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let {utility, ...valueBank} = value;
    let bank = {
      isIncome: true,
      isOutcome: true,
      ...valueBank
    };
    
    if(utility == 'income') bank.isOutcome = false;
    if(utility == 'outcome') bank.isIncome = false;
    
    this.bankService.addBank(bank);
    this.bankService.windowReplace('read');
  }

}
